import styled from "styled-components";
import DeleteIcon from "@mui/icons-material/Delete";
import useConfirm from "common/modal/ConfirmDialog";
import { fileNameGet } from "common/util/file/file_common";
import {
  CHARACTER_FILE_DELETE_CONFIRM_TEXT,
  CHARACTER_FILE_DELETE_CONFIRM_TITLE,
} from "components/common/character/CharacterSingleNav/CharacterSingleNav.const";
import { CharacterFile } from "common/character/dto/CharacterFile";
import CharacterImage from "components/common/character/file/CharacterImage";
import CharacterFileClickActLink from "components/common/character/file/CharacterFileClickActLink";
import { MouseEventHandler, useCallback, useMemo } from "react";
import { isCharacterFileRoleSignImage } from "common/character/character_common";

type CharacterFileItemProps = {
  characterFile: CharacterFile;
  deleteHandle: Function;
  onClickFileName?: (index: number) => void;
  ind: number;
};

const CharacterFileItem = ({
  characterFile,
  deleteHandle,
  onClickFileName,
  ind,
}: CharacterFileItemProps) => {
  const actionConfirm = useConfirm();

  const clickFileNameHandle: MouseEventHandler<HTMLDivElement> =
    useCallback(() => {
      if (onClickFileName) {
        onClickFileName(ind);
      }
    }, [onClickFileName, ind]);

  const isRoleSignImage: boolean = useMemo(() => {
    return isCharacterFileRoleSignImage(characterFile);
  }, [characterFile?.role]);

  const deleteClickHandle = async () => {
    let check = false;
    try {
      check = await actionConfirm({
        title: CHARACTER_FILE_DELETE_CONFIRM_TITLE,
        character: CHARACTER_FILE_DELETE_CONFIRM_TEXT,
      });
    } catch (err) {
      console.log("confirm err");
    }
    if (check) {
      deleteHandle(ind);
    }
  };

  return (
    <Div>
      <Div>
        <DivFileName
          onClick={clickFileNameHandle}
          hasClickFileNameHandling={typeof onClickFileName !== "undefined"}
          isRoleSignImage={isRoleSignImage}
        >
          {fileNameGet(characterFile.path)}
        </DivFileName>
        <div>
          <CharacterFileClickActLink characterFilePath={characterFile.path}>
            <CharacterImage characterFile={characterFile} small />
          </CharacterFileClickActLink>
        </div>
      </Div>
      <DivDelete>
        <DeleteIconNav onClick={deleteClickHandle} />
      </DivDelete>
    </Div>
  );
};

const DeleteIconNav = styled(DeleteIcon)`
  cursor: pointer;
`;

const Div = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;

const DivFileName = styled.div<{
  hasClickFileNameHandling?: boolean;
  isRoleSignImage?: boolean;
}>`
  cursor: ${(props) =>
    props.hasClickFileNameHandling ? "pointer" : "inherit"};
  text-decoration: ${(props) =>
    props.isRoleSignImage ? "underline" : "inherit"};
`;

const DivDelete = styled.div`
  margin-left: 1rem;
`;

export default CharacterFileItem;
